import React, { useState } from 'react';
import api from './api';
import { Button, Box, Typography, LinearProgress } from '@mui/material';

function PhotoUploader({ displayId }) {
  // 1. Change state to hold multiple files (or null)
  const [files, setFiles] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // 2. Update handler to accept multiple files
  const handleFileChange = (e) => {
    setFiles(e.target.files); // Get the entire FileList
    setError('');
    setSuccess('');
  };

  // 3. Update upload handler to loop
  const handleUpload = async () => {
    if (!files || files.length === 0) return;

    setIsUploading(true);
    setError('');
    setSuccess('');
    let filesUploaded = 0;
    let filesFailed = 0;

    // Loop over each file in the FileList
    for (const file of files) {
      try {
        // Step 1: Ask backend for a secure S3 upload URL
        const response = await api.post('/photos/upload-request');
        const { uploadUrl, key } = response.data;

        // Step 2: Upload the file directly to S3
        await fetch(uploadUrl, {
          method: 'PUT',
          headers: { 'Content-Type': 'image/jpeg' },
          body: file,
        });

        // Step 3: Tell our backend the upload is done
        await api.post('/photos/confirm', {
          displayId: displayId,
          key: key,
        });

        filesUploaded++;
      } catch (err) {
        console.error("Error uploading one file:", err);
        filesFailed++;
      }
    }

    setIsUploading(false);
    setSuccess(`Successfully uploaded ${filesUploaded} photo(s).`);
    if (filesFailed > 0) {
      setError(`${filesFailed} photo(s) failed to upload.`);
    }
    setFiles(null); // Clear the file input
    // Reset the file input form element
    document.getElementById('file-input').value = null;
  };

  return (
    <Box sx={{ mt: 4, p: 2, border: '1px dashed grey', borderRadius: '8px' }}>
      <Typography variant="h6" gutterBottom>
        Upload Photos
      </Typography>
      <input
        id="file-input" // Add an ID to clear it later
        type="file"
        accept="image/jpeg"
        multiple // <-- 4. ADD THIS
        onChange={handleFileChange}
        disabled={isUploading}
      />
      <Button
        variant="contained"
        onClick={handleUpload}
        disabled={!files || isUploading}
        sx={{ mt: 2 }}
      >
        Upload
      </Button>

      {isUploading && <LinearProgress sx={{ mt: 2 }} />}
      {success && <Typography color="primary" sx={{ mt: 2 }}>{success}</Typography>}
      {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
    </Box>
  );
}

export default PhotoUploader;